/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Role,
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './Role';

/**
 * 
 * @export
 * @interface UserRequest
 */
export interface UserRequest {
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    lastName: string;
    /**
     * 
     * @type {Role}
     * @memberof UserRequest
     */
    role: Role;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserRequest
     */
    superGroupIds?: Array<string>;
}

export function UserRequestFromJSON(json: any): UserRequest {
    return UserRequestFromJSONTyped(json, false);
}

export function UserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'role': RoleFromJSON(json['role']),
        'superGroupIds': !exists(json, 'superGroupIds') ? undefined : json['superGroupIds'],
    };
}

export function UserRequestToJSON(value?: UserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'role': RoleToJSON(value.role),
        'superGroupIds': value.superGroupIds,
    };
}

